import {
  type PortableTextTypeComponentOptions,
  toHTML,
} from '@portabletext/to-html'
import h from 'hyperscript'

import {
  type SanityComplexPortableText,
  type SanityInfoBox,
  type SanityQuote,
  type SanitySimplePortableText,
} from '@data/sanity/queries/types/content'
import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { getSanityImageUrl } from '@lib/image'

export const getPortableTextHtml = (
  portableText?: SanityComplexPortableText | SanitySimplePortableText,
) => {
  if (!portableText) {
    return ''
  }

  return toHTML(
    portableText.filter(({ _type }) =>
      ['block', 'quote', 'figure', 'infoBox'].includes(_type),
    ),
    {
      components: {
        types: {
          quote: ({ value }: PortableTextTypeComponentOptions<SanityQuote>) => {
            return h(
              'figure',
              {},
              h('blockquote', value.text),
              h('figcaption', value.author),
            ).outerHTML
          },
          figure: ({
            value,
          }: PortableTextTypeComponentOptions<SanityImageFragment>) => {
            const imageUrl = getSanityImageUrl(value, {
              width: value.asset?.metadata?.dimensions?.width,
              height: value.asset?.metadata?.dimensions?.height,
              fitMax: true,
              autoFormat: true,
            })

            return h('img', {
              src: imageUrl,
              alt: value.alt,
            }).outerHTML
          },
          infoBox: ({
            value,
          }: PortableTextTypeComponentOptions<SanityInfoBox>) => {
            return h('div', {}, h('h4', value.title), h('p', value.content))
              .outerHTML
          },
        },
      },
    },
  )
}
